<template>
  <a-popover :trigger="trigger" :visible="optionsVisible" @visibleChange="handleClickChange">
    <template slot="content">
      <div @click="handleClickChange(false)">
        <slot name="content"></slot>
      </div>
    </template>
    <span>
      <slot></slot>
    </span>
  </a-popover>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "‧‧‧",
    },
    trigger: {
      default: "click",
      type: String,
    },
  },

  data() {
    return {
      optionsVisible: false,
    };
  },
  methods: {
    handleClickChange(visible) {
      this.optionsVisible = visible;
    },
  },
};
</script>

<style lang="less" scoped>
</style>